<script lang="ts">
  import { Input, Button } from '@aatmanova/ui';

  interface Props {
    isCategoryFormOpen: boolean;
    categoryName: string;
    categorySlug: string;
    createCategoryMutationIsPending: boolean;
    handleSaveCategory: (e: SubmitEvent) => void;
  }

  let {
    isCategoryFormOpen = $bindable(),
    categoryName = $bindable(),
    categorySlug = $bindable(),
    createCategoryMutationIsPending,
    handleSaveCategory
  }: Props = $props();
</script>

{#if isCategoryFormOpen}
  <div class="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
    <div class="card bg-base-100 border border-base-300 p-6 space-y-6 shadow-2xl w-full max-w-md">
      <div class="flex items-center justify-between">
        <h3 class="card-title text-lg font-bold tracking-tight text-base-content">Create Product Category</h3>
        <button onclick={() => isCategoryFormOpen = false} class="btn btn-sm btn-circle btn-ghost text-base-content/75">✕</button>
      </div>

      <form onsubmit={handleSaveCategory} class="space-y-4">
        <div class="form-control w-full">
          <label for="catName" class="label">
            <span class="label-text text-xs font-semibold text-base-content/60 uppercase tracking-wider">Category Name</span>
          </label>
          <Input
            type="text"
            id="catName"
            required
            bind:value={categoryName}
            placeholder="Incense & Herbs"
          />
        </div>
        <div class="form-control w-full">
          <label for="catSlug" class="label">
            <span class="label-text text-xs font-semibold text-base-content/60 uppercase tracking-wider">Slug</span>
          </label>
          <Input
            type="text"
            id="catSlug"
            required
            bind:value={categorySlug}
            placeholder="incense-herbs"
          />
        </div>
        <div class="flex items-center justify-end gap-3 pt-4 border-t border-base-300">
          <Button
            type="button"
            onclick={() => isCategoryFormOpen = false}
            variant="outline"
            size="sm"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            disabled={createCategoryMutationIsPending}
            variant="primary"
            size="sm"
          >
            {#if createCategoryMutationIsPending}
              Saving...
            {:else}
              Create Category
            {/if}
          </Button>
        </div>
      </form>
    </div>
  </div>
{/if}
